"use strict";

import Point from "ol/geom/Point";
import GeometryLayout from "ol/geom/GeometryLayout";

/**
 * @classdesc
 * Wrapperklasse für eine OpenLayers Punkt-Geometrie.
 *
 * @class
 * @extends gc.gis.geom.GCPoint
 * @memberof gc.gis.geom
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Point} opt_point gewrappte Punkt-Geometrie-Instanz
 */
gc.gis.geom.OLPoint = function(opt_point)
{
    if (!opt_point)
    {
        opt_point = new Point([null, null]);
    }

    gc.gis.assert.isInstance(opt_point, Point);
    gc.gis.geom.GCPoint.call(this, opt_point);

    // mixin erstellen
    const source = gc.gis.geom.OLGeometry.prototype;
    for (let prop in source) {
        if (source.hasOwnProperty(prop)) {
            this[prop] = source[prop];
        }
    }
};
gc.gis.geom.OLPoint.prototype = Object.create(gc.gis.geom.GCPoint.prototype);


/**
 * Gibt die X-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} X-Koordinate
 * @public
 */
gc.gis.geom.OLPoint.prototype.getX = function ()
{
    const coord = this._geom.getCoordinates();
    return coord.length > 0 ? coord[0] : null;
};

/**
 * Gibt die Y-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} Y-Koordinate
 * @public
 */
gc.gis.geom.OLPoint.prototype.getY = function ()
{
    const coord = this._geom.getCoordinates();
    return coord.length > 1 ? coord[1] : null;
};

/**
 * Gibt die Z-Koordinate der Punkt-Geometrie zurück.
 *
 * @method
 * @return {double} Z-Koordinate
 * @public
 */
gc.gis.geom.OLPoint.prototype.getZ = function ()
{
    const coord = this._geom.getCoordinates();
    return (coord.length > 2 && this._geom.getLayout() === GeometryLayout.XYZ) ? coord[2] : null;
};

/**
 * Setzt die Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @param {double} z Z-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.OLPoint.prototype.set = function(x, y, z)
{
    const coordinate = [x, y];
    if (z !== undefined) {
        coordinate.push(z);
    }
    this._geom.setCoordinates(
        coordinate
        // coordinate.length == 2 ? GeometryLayout.XY : GeometryLayout.XYZ
    );

    return this;
};

/**
 * Setzt die XY-Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.OLPoint.prototype.setXY = function(x, y)
{
    this.set(x, y, undefined);
    return this;
};

/**
 * Setzt die XYZ-Koordinate der Punkt-Geometrie.
 *
 * @method
 * @param {double} x X-Koordinate
 * @param {double} y Y-Koordinate
 * @param {double} z Z-Koordinate
 * @return {gc.gis.geom.GCPoint}
 * @public
 */
gc.gis.geom.OLPoint.prototype.setXYZ = function (x, y, z)
{
    this.set(x, y, z);
    return this;
};